import { AuthenticatedRequest } from './../requests/request';
import { User } from "../models/user";
import { APIVersion, AuthenticatedFileRequest, HTTPMethod } from "../requests/request";
import { Company } from '../models/company';

export class API {

    /**
     * Upload a profile Picture
     * 
     * @param image Image file
     */
    public static uploadProfileImage(image: any): Promise<User> {
        let apiReqest = new AuthenticatedFileRequest<User>('/users/me/picture', HTTPMethod.POST, APIVersion.v1_0, undefined, {
            image
        });
        return apiReqest.send(User).then((response) => {
            return response.data
        })
    }

    public static updateProfile(email?: string, full_name?: string): Promise<User> {
        let apiRequest = new AuthenticatedRequest<User>('/users/me', HTTPMethod.PUT, APIVersion.v1_0, undefined, {
            email,
            full_name
        })
        return apiRequest.send(User).then((response) => {
            return response.data
        })
    }

    /**
     * Get the user
     */
    public static getUser(): Promise<User> {
        let apiRequest = new AuthenticatedRequest<User>('/users/me', HTTPMethod.GET, APIVersion.v1_0)
        return apiRequest.send(User).then((response) => {
            return response.data
        })
    }

    /**
     * Get own Company
     */
    public static getCompany(): Promise<Company> {
        let apiRequest = new AuthenticatedRequest<Company>('/users/company', HTTPMethod.GET, APIVersion.v1_0)
        return apiRequest.send(Company).then((response) => {
            return response.data
        })
    }

    /**
     * Get Company User
     */
    public static getCompanyUser(limit?: number, offset?: number): Promise<User[]> {
        let apiRequest = new AuthenticatedRequest<User>('/users/company/user', HTTPMethod.GET, APIVersion.v1_0, {
            limit,
            offset
        })
        return apiRequest.send(User).then((response) => {
            return response.data
        })
    }

    /**
     * Count Company User
     */
    public static countCompanyUser(): Promise<number> {
        let apiRequest = new AuthenticatedRequest<number>('/users/company/user/count', HTTPMethod.GET, APIVersion.v1_0)
        return apiRequest.send().then((response) => {
            return response.data
        })
    }

    /**
     * Delete a user account
     */
    public static deleteAccount(): Promise<string> {
        let apiRequest = new AuthenticatedRequest<string>('/users/me', HTTPMethod.DELETE, APIVersion.v1_0)
        return apiRequest.send().then((response) => {
            return response.data
        })
    }

    /**
     * Delete a user account
     */
    public static deleteUser(id: string): Promise<string> {
        let apiRequest = new AuthenticatedRequest<string>(`/users/${id}`, HTTPMethod.DELETE, APIVersion.v1_0)
        return apiRequest.send().then((response) => {
            return response.data
        })
    }

    /**
     * Update own Company
     */
    public static updateCompany(contact?: string, email?: string, phone_number?: string, website?: string, img_url?: string): Promise<Company> {
        let apiRequest = new AuthenticatedRequest<Company>('/users/company', HTTPMethod.PUT, APIVersion.v1_0, undefined, {
            contact,
            email,
            phone_number,
            website,
            img_url
        })
        return apiRequest.send(Company).then((response) => {
            return response.data
        })
    }
}